export enum LeadStatus {
  CustomerContacted = 1,
  CustomerInterested = 2,
  QuoteCreated = 3,
  CustomerSubmittedPO = 4,
  DeadEnd = 5,
  RejectLead = 6,
  ConvertedToCustomer = 7
}
